<template>
  <fieldset :class="{'date-picker-wrap': true, 'bg-danger' : !assertValidDate() }">
    <div class="form-grp">
      <label v-if='showLabels' :for="'id-' + name + '-day'">{{ trans('day') }}</label>
      <input pattern="^((0?[1-9])|([12][0-9])|(3[01]))$" @focus="highlight" @keypress="digitsOnly" @keyup="doneDigits" class="form-control day" :id="'id-' + name + '-day'" v-model="date.day" :placeholder="trans('day')" min="1" max="31">
    </div>
    <div class="form-grp">
      <label v-if='showLabels' :for="'id-' + name + '-month'">{{ trans('month') }}</label>
      <input pattern="^((0?[1-9])|(1[012]))$" @focus="highlight" @keypress="digitsOnly" @keyup="doneDigits" class="form-control month" :id="'id-' + name + '-month'" v-model="date.month" :placeholder="trans('month')" max="12" min="1">
    </div>
    <div class="form-grp">
      <label v-if='showLabels' :for="'id-' + name + '-year'">{{ trans('year') }}</label>
      <input pattern="^\d\d\d\d$" @focus="highlight" @keypress="digitsOnly" @keyup="doneDigits" class="form-control year" :id="'id-' + name + '-year'" v-model="date.year" :placeholder="trans('year')" :min="minDate.getFullYear()" :max="maxDate ? maxDate.getFullYear() : ''">
    </div>
    <input type="hidden" :name="name" :value="isoString()"></input>
    <slot></slot>
  </fieldset>
</template>


<script>
import TranslationMixin from '../assets/TranslationMixin.js'
import _ from 'lodash'

var pattern = /^(\d{4})-(\d{2})-(\d{2})$/

var isLeap = function (y) {
  return !(y % 4 || (!(y % 100) && y % 400))
}

var isDate = function (value) {
  var md = new Date(value)
  return isNaN(md.valueOf()) ? false : md.getFullYear() > 1899
}

export default {
  mixins: [TranslationMixin],
  props: {
    required: {
      type: Boolean,
      default: false
    },
    name: String,
    showLabels: Boolean,
    min: {
      type: String,
      default: '1900',
      validator: isDate
    },
    max: {
      type: String,
      default: new Date().toISOString().substr(0, 10),
      validator: isDate
    },
    initial: {
      type: String,
      validator: isDate,
      default: function () {
        return new Date().toISOString().substr(0, 10)
      }
    },
    minAge: {
      type: String,
      validator: function (value) {
        var v = parseInt(value)
        return isNaN(v) || v > 1
      }
    }
  },
  data () {
    return {
      date: {
        day: '',
        month: '',
        year: ''
      },
      justFocused: false,
      maxDate: null,
      minDate: null
    }
  },
  methods: {
    selectText: (inputNode) => {
      if (document.body.createTextRange) {
        const range = document.body.createTextRange()
        range.moveToElementText(inputNode)
        range.select()
      } else {
        if (window.getSelection) {
          const selection = window.getSelection()
          selection.removeAllRanges()
          inputNode.setSelectionRange(0, inputNode.value.length)
        } else {
          console.warn('Could not select text in node: Unsupported browser.')
        }
      }
    },
    highlight: function (ev) {
      var self = this
      var target = ev.target
      if (target.value.length) {
        self.selectText(target)
      }
      self.justFocused = true
    },
    controlDigits: function (event, keyDown) {
      var self = this
      var i = event.target
      var cn = i.className
      var next = ''
      var nextClass = ''
      var ln = cn.indexOf('year') > 0 ? 4 : 2
      var sel = window.getSelection()
      var selObj = null
      if (sel.toString().length) {
        selObj = sel.anchorNode.childNodes[sel.anchorOffset]
        if (selObj === i && keyDown && '0123456789'.indexOf(event.key) !== -1) {
          event.target.value = event.target.value.replace(sel.toString(), '')
        }
      }
      if (event.key.length === 1 && '0123456789'.indexOf(event.key) === -1) {
        event.preventDefault()
        return false
      } else {
        if (event.key.length === 1 && '0123456789'.indexOf(event.key) !== -1 && event.target.value.length === ln) {
          if (ln === 2 && !self.justFocused) {
            nextClass = cn.indexOf('month') > 0 ? 'year' : 'month'
            next = self.$el.getElementsByClassName(nextClass)[0]
            next.focus()
          }
        }
      }
      if (!keyDown) {
        self.justFocused = false
      }
    },
    doneDigits: function (e) {
      _.debounce(this.controlDigits, 150)(e, false)
    },
    digitsOnly: function (e) {
      _.debounce(this.controlDigits, 150)(e, true)
    },
    dateObj: function (a) {
      var attrs = ['year', 'month', 'day']
      var ints = pattern.exec(a)
      if (!ints) {
        return {}
      }
      ints.shift()
      return ints.reduce(function (obj, val, i) {
        obj[attrs[i]] = parseInt(val)
        return obj
      }, {})
    },
    isoDate: function () {
      var self = this
      var d = self.date
      // month is 0-based
      return d.year ? new Date(d.year, d.month - 1, d.day) : null
    },
    assertValidDate: function () {
      var self = this
      var d = arguments.length > 0 ? self.dateObj(arguments[0]) : self.date
      var jsDate = self.isoDate()
      var valid = true
      if (!d.day && !d.month && !d.year) {
        return true
      } else {
        valid = d.day && d.month && d.year && jsDate
        if (valid) {
          valid = jsDate >= self.minDate && jsDate <= self.maxDate && d.month < 13
        }
        if (valid) {
          if (d.month === 2) {
            valid = isLeap(d.year) ? d.day < 30 : d.day < 29
          } else {
            valid = [4, 6, 9, 11].indexOf(d.month) > -1 && d.day < 31 || d.day < 32
          }
        }
        return valid
      }
    },
    pad: function (n, width, z) {
      z = z || '0'
      n = n + ''
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
    },
    isoString: function () {
      var self = this
      var d = self.date.day
      var m = self.date.month
      var y = self.date.year
      return self.date.year && self.assertValidDate() ? y + '-' + self.pad(m, 2) + '-' + self.pad(d, 2) : ''
    }
  },
  computed: {
    isValidDate: function () {
      return this.assertValidDate()
    }
  },
  created: function () {
    var self = this
    self.maxDate = self.max ? new Date(self.max) : new Date()
    self.minDate = new Date(self.min)
    if (self.initial) {
      self.date = self.dateObj(self.initial)
    }
  }
}
</script>

<style scoped>
  .date-picker-wrap {
    padding: 0 !important;
    border: 0 none !important;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    -webkit-transition: none !important;
    transition: none !important;
  }
  .form-grp {
    display: inline-block
  }
  .form-grp>label {
    display: block
  }
  .form-grp>input {
    min-width: 2em;
    max-width: 4.2em;
  }
  .bg-danger {
    background-color: #fde
  }
  input {
    text-align: right
  }
  input[type=number] { -moz-appearance: textfield; }
  input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }
  ::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    text-align: center;
    margin: 0 -.5em
  }
  ::-moz-placeholder { /* Firefox 19+ */
    text-align: center;
    margin: 0 -.5em
  }
  :-ms-input-placeholder { /* IE 10+ */
    text-align: center;
    margin: 0 -.5em
  }
  :-moz-placeholder { /* Firefox 18- */
    text-align: center;
    margin: 0 -.5em
  }
</style>



// WEBPACK FOOTER //
// DateField.vue?170e8ffe